export const SubjectPronounsFormal = [
    // Formal / Polite
    { id: "i-formal", korean: '저', english: 'I (formal)', romanization: 'jeo' },
    { id: "you-formal", korean: '당신', english: 'You (formal)', romanization: 'dang-sin' },
    { id: "he-formal", korean: '그분', english: 'He (formal)', romanization: 'geu-bun' },
    { id: "she-formal", korean: '그분', english: 'She (formal)', romanization: 'geu-bun' },
    { id: "we-formal", korean: '저희', english: 'We (formal)', romanization: 'jeo-hui' },
    { id: "they-formal", korean: '그분들', english: 'They (formal)', romanization: 'geu-bun-deul' },
];

export const SubjectPronounsInformal = [
    // Informal / Casual
    { id: "i-informal", korean: '나', english: 'I (informal)', romanization: 'na' },
    { id: "you-informal", korean: '너', english: 'You (informal)', romanization: 'neo' },
    { id: "he-informal", korean: '그', english: 'He (informal)', romanization: 'geu' },
    { id: "she-informal", korean: '그녀', english: 'She (informal)', romanization: 'geu-nyeo' },
    { id: "we-informal", korean: '우리', english: 'We (informal)', romanization: 'u-ri' },
    { id: "they-informal", korean: '그들', english: 'They (informal)', romanization: 'geu-deul' },
];

export const ObjectPronounsFormal = [
    // Formal / Polite
    { id: "me-formal", korean: '저를', english: 'me (formal)', romanization: 'jeo-reul' },
    { id: "you-formal", korean: '당신을', english: 'you (formal)', romanization: 'dang-sin-eul' },
    { id: "him-formal", korean: '그분을', english: 'him (formal)', romanization: 'geu-bun-eul' },
    { id: "her-formal", korean: '그분을', english: 'her (formal)', romanization: 'geu-bun-eul' },
    { id: "us-formal", korean: '저희를', english: 'us (formal)', romanization: 'jeo-hui-reul' },
    { id: "them-formal", korean: '그분들을', english: 'them (formal)', romanization: 'geu-bun-deul-eul' },
];

export const ObjectPronounsInformal = [
    // Informal / Casual
    { id: "me-informal", korean: '나를', english: 'me (informal)', romanization: 'na-reul' },
    { id: "you-informal", korean: '너를', english: 'you (informal)', romanization: 'neo-reul' },
    { id: "him-informal", korean: '그를', english: 'him (informal)', romanization: 'geu-reul' },
    { id: "her-informal", korean: '그녀를', english: 'her (informal)', romanization: 'geu-nyeo-reul' },
    { id: "us-informal", korean: '우리를', english: 'us (informal)', romanization: 'u-ri-reul' },
    { id: "them-informal", korean: '그들을', english: 'them (informal)', romanization: 'geu-deul-reul' },
];

export const PossessivePronounsFormal = [
    // Formal / Polite
    { id: "my-formal", korean: '저의', english: 'my (formal)', romanization: 'jeo-ui' },
    { id: "your-formal", korean: '당신의', english: 'your (formal)', romanization: 'dang-sin-ui' },
    { id: "his-formal", korean: '그분의', english: 'his (formal)', romanization: 'geu-bun-ui' },
    { id: "her-formal", korean: '그분의', english: 'her (formal)', romanization: 'geu-bun-ui' },
    { id: "our-formal", korean: '저희의', english: 'our (formal)', romanization: 'jeo-hui-ui' },
    { id: "their-formal", korean: '그분들의', english: 'their (formal)', romanization: 'geu-bun-deul-ui' },
];

export const PossessivePronounsInformal = [
    // Informal / Casual
    { id: "my-informal", korean: '내', english: 'my (informal)', romanization: 'nae' },
    { id: "your-informal", korean: '네', english: 'your (informal)', romanization: 'ne' },
    { id: "his-informal", korean: '그의', english: 'his (informal)', romanization: 'geu-ui' },
    { id: "her-informal", korean: '그녀의', english: 'her (informal)', romanization: 'geu-nyeo-ui' },
    { id: "our-informal", korean: '우리의', english: 'our (informal)', romanization: 'u-ri-ui' },
    { id: "their-informal", korean: '그들의', english: 'their (informal)', romanization: 'geu-deul-ui' },
];

export const ReflexivePronounsFormal = [
    // Formal / Polite
    { id: "myself-formal", korean: '저 자신', english: 'myself (formal)', romanization: 'jeo ja-sin' },
    { id: "yourself-formal", korean: '당신 자신', english: 'yourself (formal)', romanization: 'dang-sin ja-sin' },
    { id: "himself-formal", korean: '그분 자신', english: 'himself (formal)', romanization: 'geu-bun ja-sin' },
    { id: "herself-formal", korean: '그분 자신', english: 'herself (formal)', romanization: 'geu-bun ja-sin' },
    { id: "ourselves-formal", korean: '저희 자신', english: 'ourselves (formal)', romanization: 'jeo-hui ja-sin' },
    { id: "themselves-formal", korean: '그분들 자신', english: 'themselves (formal)', romanization: 'geu-bun-deul ja-sin' },
];

export const ReflexivePronounsInformal = [
    // Informal / Casual
    { id: "myself-informal", korean: '자신', english: 'myself (informal)', romanization: 'ja-sin' },
    { id: "yourself-informal", korean: '자신', english: 'yourself (informal)', romanization: 'ja-sin' },
    { id: "himself-informal", korean: '그 자신', english: 'himself (informal)', romanization: 'geu ja-sin' },
    { id: "herself-informal", korean: '그녀 자신', english: 'herself (informal)', romanization: 'geu-nyeo ja-sin' },
    { id: "ourselves-informal", korean: '우리 자신', english: 'ourselves (informal)', romanization: 'u-ri ja-sin' },
    { id: "themselves-informal", korean: '그들 자신', english: 'themselves (informal)', romanization: 'geu-deul ja-sin' },
];

export const DemonstrativePronounsFormal = [
    // Formal / Polite
    { id: "this-formal", korean: '이것', english: 'this (formal)', romanization: 'i-geot' },
    { id: "that-near-formal", korean: '그것', english: 'that (near the listener, formal)', romanization: 'geu-geot' },
    { id: "that-far-formal", korean: '저것', english: 'that (far from both, formal)', romanization: 'jeo-geot' },
    { id: "these-formal", korean: '이것들', english: 'these (formal)', romanization: 'i-geot-deul' },
    { id: "those-near-formal", korean: '그것들', english: 'those (near the listener, formal)', romanization: 'geu-geot-deul' },
    { id: "those-far-formal", korean: '저것들', english: 'those (far from both, formal)', romanization: 'jeo-geot-deul' },
];

export const DemonstrativePronounsInformal = [
    // Informal / Casual
    { id: "this-informal", korean: '이거', english: 'this (informal)', romanization: 'i-geo' },
    { id: "that-near-informal", korean: '그거', english: 'that (near the listener, informal)', romanization: 'geu-geo' },
    { id: "that-far-informal", korean: '저거', english: 'that (far from both, informal)', romanization: 'jeo-geo' },
    { id: "these-informal", korean: '이거들', english: 'these (informal)', romanization: 'i-geo-deul' },
    { id: "those-near-informal", korean: '그거들', english: 'those (near the listener, informal)', romanization: 'geu-geo-deul' },
    { id: "those-far-informal", korean: '저거들', english: 'those (far from both, informal)', romanization: 'jeo-geo-deul' },
];

export const InterrogativePronounsFormal = [
    // Formal
    { id: "who-formal", korean: '누구', english: 'who (formal)', romanization: 'nu-gu' },
    { id: "what-formal", korean: '무엇', english: 'what (formal)', romanization: 'mu-eot' },
    { id: "which-formal", korean: '어느', english: 'which (formal)', romanization: 'eo-neu' },
    { id: "whose-formal", korean: '누구의', english: 'whose (formal)', romanization: 'nu-gu-ui' },
];

export const InterrogativePronounsInformal = [
    // Informal
    { id: "who-informal", korean: '누구', english: 'who (informal)', romanization: 'nu-gu' },
    { id: "what-informal", korean: '뭐', english: 'what (informal)', romanization: 'mwo' },
    { id: "which-informal", korean: '어느', english: 'which (informal)', romanization: 'eo-neu' },
    { id: "whose-informal", korean: '누구의', english: 'whose (informal)', romanization: 'nu-gu-ui' },
];

export const IndefinitePronounsFormal = [
    // Formal
    { id: "someone-formal", korean: '누군가', english: 'someone (formal)', romanization: 'nu-gun-ga' },
    { id: "anyone-formal", korean: '누구든지', english: 'anyone (formal)', romanization: 'nu-gu-deun-ji' },
    { id: "everyone-formal", korean: '모두', english: 'everyone (formal)', romanization: 'mo-du' },
    { id: "something-formal", korean: '무언가', english: 'something (formal)', romanization: 'mu-eon-ga' },
    { id: "anything-formal", korean: '아무거나', english: 'anything (formal)', romanization: 'a-mu-geo-na' },
];

export const IndefinitePronounsInformal = [
    // Informal
    { id: "someone-informal", korean: '누군가', english: 'someone (informal)', romanization: 'nu-gun-ga' },
    { id: "anyone-informal", korean: '누구든지', english: 'anyone (informal)', romanization: 'nu-gu-deun-ji' },
    { id: "everyone-informal", korean: '모두', english: 'everyone (informal)', romanization: 'mo-du' },
    { id: "something-informal", korean: '뭔가', english: 'something (informal)', romanization: 'mwon-ga' },
    { id: "anything-informal", korean: '아무거나', english: 'anything (informal)', romanization: 'a-mu-geo-na' },
];
